import { computed, Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class AppState {
  private _loading = signal(false);
  public loading = computed(() => { return this._loading() } );

  constructor() { }

  setLoadingState(state: boolean): void {
    this._loading.set(state);
  }
}